export default __webpack_public_path__ + "static/web_portal_process-220f6f15d7b8a4ff65500283881d7e00.webp";